import { createDraftSafeSelector, createSelector } from "@reduxjs/toolkit";
import { RootState } from "../types";

export const createTypedDraftSafeSelector =
  createDraftSafeSelector.withTypes<RootState>();

export const createTypedSelector =
createSelector.withTypes<RootState>();